<p-confirmDialog header="Confirmation" key="confirmDelete" icon="pi pi-exclamation-triangle"
                 [style]="{width: '350px'}" acceptButtonStyleClass="p-button-text" rejectButtonStyleClass="p-button-text" />
<p-toast />
@if (progressService.blocked | async) {
    <p-blockUI [blocked]="progressService.blocked | async">
        <p-progressSpinner aria-label="Loading" />
        <br>
        <div style="font-size: 3rem">{{progressService.progressMessage | async}}</div>
    </p-blockUI>
}
<br>

<div class="layout-wrapper" [class]="containerClass">
    <app-topbar />
    <div class="layout-sidebar">
        <app-sidebar />
    </div>
    <div class="layout-main-container">
        <div class="layout-main">
            <router-outlet />
        </div>
        <app-footer />
    </div>
    <app-configurator />
    <div class="layout-mask"></div>
</div>
